import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-long-up', 'ArrowLongUp', [["path",{"d":"m8 6 4-4m0 0 4 4m-4-4v20","key":"svg-0"}]]);